import { format, isPast } from 'date-fns';
import React from 'react';
import { useErrorHandler } from 'react-error-boundary';

// Components
import MemberStatusIcon from '@icons/MemberStatusIcon';
import LoadingArea from '../LoadingArea';
import { BodyMedium, ButtonLink, DivWithBgPatternWhite, DivWithShadow, H5, LinkText } from '@styled';
import ErrorHandler from '../../../../icsc-app/js/components/_molecules/ErrorHandler'; // TODO: shared items should not reference a specific module

// Helpers
import { getMemberStatusText } from '@general/helpers/member.helpers';
import { getDateFromApiDate } from '@general/dates';
import useViewer from '@hooks/useViewer';

const MembershipStatusCard = () => {
    const { error, viewer } = useViewer();
    useErrorHandler(error);

    if (!viewer) {
        return (
            <DivWithShadow>
                <LoadingArea minHeight={470} />
            </DivWithShadow>
        );
    }

    const { status, paidThru, accountId } = viewer;
    const statusText = getMemberStatusText(status, paidThru);

    return (
        <ErrorHandler>
            <DivWithShadow className="fade-in-fast" style={{ flexGrow: 1, display: 'flex' }}>
                <DivWithBgPatternWhite style={styles.container}>
                    <div className="mb-2">
                        <MemberStatusIcon statusText={statusText} />
                    </div>

                    <H5 className="mb-4">{statusText}</H5>
                    <BodyMedium className="mb-4 text-center">Member ID#: {accountId}</BodyMedium>

                    {paidThru && (
                        <BodyMedium className="mb-4 text-center">
                            Your membership {isPast(getDateFromApiDate(paidThru)) ? 'expired' : 'expires'} on
                            <br />
                            {format(getDateFromApiDate(paidThru), 'MMMM d, yyyy')}
                        </BodyMedium>
                    )}

                    <div className="row" style={{ width: '100%' }}>
                        <div className="col-md-6 mb-1.25rem col-lg p-0">
                            <ButtonLink className="w-100" href="/membership/start">
                                <LinkText className="text-white">Renew Membership</LinkText>
                            </ButtonLink>
                        </div>

                        <div className="col-md-6 col-lg p-0">
                            <ButtonLink className="w-100" href="/my-icsc/edit-billing">
                                <LinkText className="text-white">Manage Billing</LinkText>
                            </ButtonLink>
                        </div>
                    </div>
                </DivWithBgPatternWhite>
            </DivWithShadow>
        </ErrorHandler>
    );
};

const styles = {
    container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        flexGrow: 1,
        padding: '40px 50px',
    },
};

// MembershipStatusCard.propTypes = {
// };

export default MembershipStatusCard;
